import Http from '../utils/http'

export const getSalesReport = (params = {}) => Http.get(`/reports/sales`, { params })

export const getPipelineReport = (id) => Http.get(`/reports/pipeline/${id}`)

export const getLossReasonsReport = (params = {}) => Http.get(`/reports/loss-reasons`, { params })

export const getSourcesReport = (params = {}) => Http.get(`/reports/sources`, { params })

export const getDealsReport = (params = {}) => Http.get(`/reports/deals`, { params })

export const getTasksReport = (params = {}) => Http.get(`/reports/tasks`, { params })

export const getCountTasks = (params = {}) => Http.get(`/reports/tasks/count`, { params })

export const getFollowUpsReport = (params = {}) => Http.get(`/reports/follow-ups`, { params })

export const getFollowUpsTimeline = (params = { page: 1 }) => Http.get(`/reports/follow-ups/timeline`, { params })



// WEBPACK FOOTER //
// ./src/services/reports.js